export default __webpack_public_path__ + "static/media/book.2994cea8.pdf";